import React from 'react';
import rootDispatcher from '../../@packages/@bd-uikit-web/js-helpers/rootDispatcher';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';
import Cookies from 'js-cookie';
import { storeHistory } from '../actions/playlistActions';
import { connect } from "react-redux";
import store from 'store';
import { getDeviceName } from './utils'

export class Register extends React.Component {

  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.state = {
      emailId: '',
      disable: false,
      loader: false,
    }
  }

  componentWillMount() {
    this.props.setHistory(this.props.history);
  }

  handleKeyPress(e) {
    switch (e.which) {
      case 13:
        this.refs.btn.focus();
        break;
    }
  }

  handleSubmit(e) {
    this.setState({
      loader: true
    })
    switch (e.which) {
      case 13:
        const { emailId } = this.state;
        if (emailId == '') {
          rootDispatcher.dispatch('NB:OPEN', {
            type: 'error',
            msg: "Enter Email!",
          });
          this.setState({
            loader: false
          });
          return;
        }
        else if (!emailId.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
          rootDispatcher.dispatch('NB:OPEN', {
            type: 'error',
            msg: "Enter valid Email!",
          });
          this.setState({
            loader: false
          });
          return;
        }
        this.setState({
          disable: true
        })

        this.register(emailId)
    }
  }

  register(emailId) {
    bdReq.post('/emailLogin', { emailId })
      .then((data) => {
        if (!data.success) {
          rootDispatcher.dispatch('NB:OPEN', {
            type: 'error',
            msg: body.message,
          });
          return;
        }
        rootDispatcher.dispatch('NB:OPEN', {
          type: 'success',
          msg: `User was created with email "${emailId}".`,
        });
        this.setState({
          loader: false
        })
        const { user, ...token } = data.body;
        store.remove('auth__user');
        store.set('auth__user', user);
        bdAuth._storeToken(token);
        const id = user.id ? user.id : user;
        bdReq.get(`/users/${id}/subscriptions`)
          .then((response) => {
            if (response.status != 200) {
              this.props.history.push('/Notice/0');
              store.remove('subscription');
              store.set('subscription', "no");
            }
            else {
              store.remove('subscription');
              store.set('subscription', "yes");
              store.remove('description');
              store.set('description', response.body.plan.description);
              this.props.history.push('/Home');
            }
          })
          .catch(err => { console.log(err) });

        store.remove('auth__user');
        store.set('auth__user', user);
        bdAuth._storeToken(token);

        const uid = getDeviceName();
        const name = `${store.get('TV_name')}`;
        const orientation = 'landscape';
        const interval = 120000;
        const highQuality = false;
        const mute = false;
        bdReq.post(`/users/${id}/devices`, { uid, name, orientation, interval, highQuality, mute })
          .then((data) => {
            store.set('device-name', data.body.name);
            store.set('device-id', data.body.id);
          })
          .catch(() => { })
      })
      .catch(err => {
        this.register(emailId)
      });
  }

  render() {
    return (
      <section className="join">
        {this.state.loader ? <div > <span className="spinner spinner--small loader regLoader" style={{ zIndex: '9' }}></span></div> : null}
        <video className="join__video" src="https://assets.blackdove.com/videos/simon_christen___golden_gate_bridge.mp4" autoPlay loop poster="data:image/gif,AAAA"></video>
        <div className="join__wrapper">
          <div className="join__wrapper__container" style={{ top: '-3em' }}>
            <h3 className="join__wrapper__container__title-register h--spacing-sm">Create account</h3>
            <h5 className="join__wrapper__container__subtitle-register row row--push-btm-s h--normalize-weight ">
              Explore, collect and display 1000's of new<br />media artwork from around the world.
            </h5>
            <div className="row row--push-btm-xs">
              <div className="col-12">
                <input className="txtField" tabIndex="1" value={this.state.emailId} type='email' placeholder='Email' onFocus={() => { this.setState({ disable: false }) }} onKeyDown={this.handleKeyPress} onChange={(e) => this.setState({ emailId: e.target.value })} autoFocus='true'></input>
              </div>
            </div>

            <div className="row row--push-btm-xs">
              <div className="col-12">
                <button tabIndex="4" onBlur={() => { this.setState({ loader: false }) }} disabled={this.state.disable} ref="btn" className="btn btn--round btn--block btn--transclucent regBtn" onKeyDown={this.handleSubmit} onClick={() => { this.handleSubmit({ which: 13 }) }}>Create Account</button>
              </div>
            </div>

            <div className="row">
              <div className="col-12 join__wrapper__container__line">
                <hr />
              </div>
            </div>

            <div className="row row--push-btm-xs">
              <div className="col-12">
                <button tabIndex="5" onClick={() => {
                  this.props.history.push('/Pair')
                }} className="btn btn--round btn--block btn--transclucent regBtn">Login</button>
              </div>
            </div>

            <div className="join__wrapper__container__btmTxt">
              By clicking on create account, you agree to<br />Blackdove's <a href="#" tabIndex="6" onClick={() => {
                    this.props.history.push('/agreement');
                    }} className="join__wrapper__container__btmTxt__link">terms & conditions</a> and <a href="#" tabIndex="7" onClick={() => {
                      this.props.history.push('/policy');
                      }}className="join__wrapper__container__btmTxt__link">privacy policy</a>.
            </div>
          </div>

          <div className="join__wrapper__footer">
            <div className="row" style={{ padding: '0 1.8em' }}>
              <div className="col-4">
                <div tabIndex="8" className="btn btn--round btn--dark pull-left back_btn regBtn" style={{ padding: '0.6em 1.8em', fontSize: '1.3em' }} onClick={() => this.props.history.push('/freemium')}><span className="ion-chevron-left arrowBack"> </span> Back</div>
              </div>
              <div className="col-4" >
                <img className="join__wrapper__footer__logo" style={{ height: '70%', width: '150px' }} src="https://assets.blackdove.com/images/bd_logo_horizontal_alternate.svg" />
              </div>
              <div className="col-4">
                <div style={{ textAlign: 'right', marginTop: '4px' }}>
                  <h6 className="h--no-spacing" style={{ fontSize: '0.8em' }}>Golden Gate Twilight</h6>
                  <small>Simon Christen</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}
const mapDispatchToProps = (dispatch) => ({
  setHistory: (history) => dispatch(storeHistory(history)),
  fetchPlaylist: () => fetchPlaylist(dispatch)
});

export default connect((state) => {
  return {
  }
}, mapDispatchToProps)(Register)